import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGear = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .23,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2.15195 10.2635L21.8481 13.7365",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.3969 8.5798L2.60307 15.4202",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.4279 4.33956L5.57214 19.6604",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.57984 2.60307L15.4202 21.3969",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.33956 5.57212L19.6604 18.4279",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7365 2.15192L10.2635 21.8481",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 8,
				transform: "rotate(10 12 12)",
				fill: "white",
				stroke: "black",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0191 11.993L2.60308 15.4202",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.026 12.0218L19.6605 18.4279",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7365 2.15192L12 12",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 2,
				transform: "rotate(10 12 12)",
				fill: "white",
				stroke: "black",
				strokeWidth: 2
			})
		]
	})
});
const ForwardRef = forwardRef(SvgGear);
export { ForwardRef as ReactComponent };
